import { FirebaseApp, initializeApp } from "firebase/app"
import { getAnalytics, Analytics } from "firebase/analytics";
import config from './config'

export let app: FirebaseApp
export let analytics: Analytics | undefined

(function getFirebase() {
  if (typeof window !== "undefined") {
    app = initializeApp(config.firebase)
    analytics = getAnalytics(app);
  }
})()
